import { defineDataFrame } from "./index";

/** Standalone entry that guarantees data-frame registration for direct browser usage. */
defineDataFrame();
